<template>
    <div>
        <vs-row>
            <vs-col vs-align="left" vs-w="6">

                <vs-button
                    v-if="can('create', 'campaigns')"
                    class="ml-5"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="showFormCreate"
                >
                    Ajouter une nouveau bloc
                </vs-button>

                <DialogPrompt
                    :active.sync="showPopup"
                    :title="getDataPrompt.title"
                    cancel-text="Annuler"
                    accept-text="Enregistrer"
                    :button-accept="getDataPrompt.btnAccept"
                    :is-valid="!formError"
                    @cancel="resetResource"
                    @close="resetResource"
                    @accept="saveResource"
                >
                     <BlocForm
                        v-model="resource"
                        :type="formType"
                        @error="setFormError"
                    />
                </DialogPrompt>


                <DialogPrompt
                    :active.sync="showPopupQuestion"
                    :title="can('update', 'questions') ? 'Modifier une question' : 'Consulter une question'"
                    cancel-text="Fermer"
                    accept-text="Enregistrer"
                    :button-accept="can('update', 'questions') ? 'filled' : 'false'"
                    :is-valid="!questionFormError"
                    @cancel="() => resourceQuestion = {}"
                    @close="() => resourceQuestion = {}"
                    @accept="saveQuestion"
                >
                     <QuestionForm
                        v-model="resourceQuestion"
                        :type="can('update', 'questions') ? 'update' : 'show'"
                        @error="(error) => questionFormError = error"
                    />
                </DialogPrompt>
            </vs-col>
            <vs-col vs-type="flex" vs-align="left" vs-w="6" />
        </vs-row>

        <vs-table
            :sst="true"
            @search="eventSearchItems"
            @sort="eventSortByCol"
            search
            :no-data-text="loading ? `Chargement de vos données...` : `Aucune donnée à afficher`"
            style="width:100%"
            :data="itemsData"
            :loading="true"
            >
            <template slot="thead">
                <vs-th>
                    <Sort 
                        name="title" 
                        :value="apiParams.sortBy.title"
                        @sort="eventSortByCol" 
                    >
                        Libellé
                    </Sort>
                </vs-th>
                <vs-th>
                    <Sort 
                        name="type" 
                        :value="apiParams.sortBy.type"
                        @sort="eventSortByCol" 
                    >
                        Type
                    </Sort>
                </vs-th>
                <vs-th>
                    <Sort 
                        name="updated_at" 
                        :value="apiParams.sortBy.updated_at"
                        @sort="eventSortByCol" 
                    >
                        Modifier le
                    </Sort>
                </vs-th>
                <vs-th>
                    Questions
                </vs-th>
                <vs-th></vs-th>
            </template>

            <template>
                <vs-tr v-for="(item, i) in items.data" :key="i">
                    <vs-td>
                        {{ get(item, ':title') }}
                    </vs-td>
                    <vs-td>
                        {{ get(item, ':type') }}
                    </vs-td>
                    <vs-td>
                        {{ localeDateTime(get(item, ':updated_at')) }}
                    </vs-td>
                    <vs-td>
                        <vs-chip color="primary" v-for="(question, i) in get(item, ':questions')" :key="i">
                            <span 
                                name="zone" 
                                style="cursor: pointer !important; min-height: 26px;min-width: 26px; padding-top: 6px;"
                                @click="showQuestionForm(question)"
                            >
                                {{ question.title }}
                            </span>
                        </vs-chip>
                    </vs-td>
                    <vs-td class="action">
                        <div class="action-wrapper">
                            <vs-button
                                v-if="can('update', 'blocs', item.id)"

                                v-tooltip="'Modifier'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-edit"
                                @click.stop="showFormUpdate(item)"
                            />

                            <vs-button
                                v-if="can('delete', 'blocs', item.id)"
                                v-tooltip="'Supprimer'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-trash"
                                @click.stop="removeResource(item)"
                            />
                        </div>
                    </vs-td>
                </vs-tr>
            </template>

        </vs-table>

        <vs-row>
            <vs-col class="mt-4" v-if="items.total > 0">
                <vs-pagination :total="Math.ceil(items.total / apiParams.perpage)" v-model="currentPage"></vs-pagination>
            </vs-col>
        </vs-row>
    </div>

</template>

<script>

import BlocForm from '@components/views/rh/referentiel/blocs/BlocForm';
import QuestionForm from '@components/views/rh/referentiel/questions/QuestionForm';
import { localeDateTime } from "@assets/utils/helpers/helpers.js";

export default {
    name: 'Blocs',
    components: {
        BlocForm,
        QuestionForm
    },
    props: {
        api: {
            type: String
        },
        perpage: {
            type: String
        }
    },
    data() {
        return {
            log: console.log,
            localeDateTime,
            config: [],
            currentPage: 1,
            loading: false,
            showPopup: false,
            showPopupExpress: false,
            showPopupQuestion: false,
            question: null,
            resource: {
                id: null,
                title: null,
                type: null,
                description: null,
                levels: {
                    level_0: null,
                    level_1: null,
                    level_2: null,
                    level_3: null,
                },
                questions: []
            },
            resourcesExpress: [],
            resourceQuestion: {},
            formExpressError: true,
            formError: true,
            questionFormError: true,
            formType: "create",
            prompt: {
                show: {
                    title: 'Consulter une bloc',
                    btnAccept: 'false'
                },
                create: {
                    title: 'Ajouter une bloc',
                    btnAccept: 'filled'
                },
                update: {
                    title: 'Modifier une bloc existante',
                    btnAccept: 'filled'
                }
            }
        }
    },

    watch: {
        loading(value) {
            if (value) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        }
    },

    computed: {
        getDataPrompt() {
            switch(this.formType) {
                case 'show':
                    return this.prompt.show
                    break;
                case 'create':
                    return this.prompt.create
                    break;
                case 'update':
                    return this.prompt.update
                    break;
                default:
                    return this.prompt.show
            }
        },
    },

    methods: {
        showFormCreate() {
            this.resetResource();
            this.formType = "create";
            this.showPopup = true;
        },

        showFormUpdate(resource) {
            this.setResource(resource);
            this.formType = "update";
            this.showPopup = true
        },

        saveResource() {
            let data = window._.cloneDeep(this.resource)
            data.questions = data.questions.map(q => q.id)

            if (data.id) {
                this.apiUpdate(
                    data, 
                    data.id,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true
                );
            } else {
                this.apiCreate(
                    data,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true
                );
            }
        },

        removeResource(resource) {
            this.apiDelete(resource.id, () => this.loadItems());
        },

        setResource(data) {
            this.resource = JSON.parse(JSON.stringify(data));
        },

        resetResource() {
            this.resource = {
                id: null,
                title: null,
                type: null,
                description: null,
                levels: {
                    level_0: null,
                    level_1: null,
                    level_2: null,
                    level_3: null,
                },
                questions: []
            }
        },

        setFormError (value) {
            this.formError = value;
        },

        showQuestionForm(question) {
            this.resourceQuestion = {...question};
            this.showPopupQuestion = true;
        },

        saveQuestion() {
            let data = window._.cloneDeep(this.resourceQuestion)
            window.axios({
                method: 'patch',
                url: `/api/referentiel/questions/${data.id}`,
                data: data,
            })
            .then(response => {
                if (response.status === 200 && response.data != '') {
                    this.notifySuccess('Succès', 'Élement modifié avec succès !')
                    this.loadItems();
                } else {

                    this.notifyError('Erreur', `Une erreur est survenue lors de la modification`)
                }
            })
            .catch((err, data) => {
                console.log(err.response);
                this.notifyErrorValidation(err)
                this.showPopupQuestion = true
            })
        }

    },
    created() {
        this.apiParams.include = ['questions'];
        this.apiParams.sortBy = {updated_at: "desc"}
        this.loadItems();

        // Ouvrir le formulaire de création au chargement de la page si argument create
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('create')) {
            this.showFormCreate();
        }
    }
}
</script>
